<style>
    .cdk-overlay-container {
        z-index: 2000;
    }
    svg:focus {
        outline: none !important;
    }

    button:focus {
        outline: none !important;
    }
</style>

<div class="container-fluid padMob" style="padding-left: 15px; border-radius: 10px; background-color: #f8f8f8;{{prTypeID == 2  ? 'min-width: 1000px;' : 'max-width: 500px; border-radius: 10px;'}}">
    <div class="row ">
        <div class="col-md-12 col-12 col-xs-12 pad0" style="margin-top: 15px;">
            <div style="display: flex;">
                <div class="col-md-8 col-8 col-sm-8  inLneBlk  padHeder" style="padding-bottom: 0px;">
                    <h4 style="font-size: 22px;">{{prTypeID == 1 ? 'Create Production Job' : 'Create Project'}}</h4>
                </div>
        
                <div class="col-md-4 col-4 col-sm-4  inLneBlk padHeder padicon" style="padding-bottom: 0px;" data-dismiss="modal">
                    <!-- <span class="pluseMar" (click)="openEntryModal()" title ="Add Product" style="font-size: 20px; color: #008080; margin-right: 5px; position: relative;cursor: pointer;">
                        <i class="zmdi zmdi-plus"></i>
                    </span> -->
                    <span *ngIf="prTypeID == 1" class="darkBlueButton brdrRadius3"
                    style="font-size:13px;"(click)="openEntryModal()">
                    <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                    <span> Add Item </span>
                    </span>
                    <!-- <div class="btn btn-teal" (click)="openEntryModal()" title="Add Product" style="padding: 3px 13px 3px; font-size: 16px; line-height: 1.66em; float: right;"> <i class="zmdi zmdi-plus" aria-hidden="true"></i></div> -->
                    <i  (click)="close()" class="closeMdl zmdi zmdi-close" style="padding: 8px 12px !important;float: right; font-size: 20px;" ></i>
                </div>
            </div>
        </div>

        <div *ngIf="!isMobileView" class="col-md-12 col-12 col-xs-12 pad0" style="display: flex;">
            <!-- left -->
            <div class="{{prTypeID == 2 ? 'col-md-6 col-6 col-xs-6 pad0' : 'col-md-12 col-12 col-xs-12 pad0'}}">
                <div class="col-md-12 col-12 col-xs-12 pad0" style="margin-top: 0px;">
                    <!-- <div class="col-md-3 col-4 col-sm-12  inLneBlk  padHeder" style="padding-bottom: 0px;">
                        <span> Job No : </span>
                    </div> -->
                    <div class="col-md-12 col-12 col-sm-12  inLneBlk  padHeder">
                        <span *ngIf="prTypeID == 2">
                            <!-- <input type="text" id="txtItem" class="form-control " tabindex="1" placeholder="Job No."
                                title="Job No" captalize-first style=" width: 40%;text-align: left;" maxlength="20" /> -->
                            <!-- <mat-form-field out class="example-full-width" style="width: 100%; " appearance="outline">
                                <mat-label>Project Title</mat-label>
                                <input matInput tabindex="1" maxlength="100" [(ngModel)]="data.projectWipNo">
                            </mat-form-field> -->
                            <div style="display: flex; gap: 5px;">
                                <div class="label-new">Project Title</div>
                                <span *ngIf="lastProjectWIPNo" style="color: #777; font-weight: normal; font-size: 12px; padding-bottom: 5px;">(Prev: {{lastProjectWIPNo}})</span>
                            </div>
                            <input type="text" [(ngModel)]="data.projectWipNo" class="form-control fn13 bzInput bzInputPad" maxlength="100" style="padding: 8px 5px !important;" placeholder="Enter Project Title" tabindex="1">

                        </span>

                        <span *ngIf="prTypeID == 1">
                            <!-- <input type="text" id="txtItem" class="form-control " tabindex="1" placeholder="Job No."
                                title="Job No" captalize-first style=" width: 40%;text-align: left;" maxlength="20" /> -->
                            <!-- <mat-form-field out class="example-full-width" style="width: 40%; " appearance="outline">
                                <mat-label >WIP No.</mat-label>
                                <input matInput tabindex="1" maxlength="20" [(ngModel)]="data.WipNo">
                            </mat-form-field> -->
                            <div style="display: flex; gap: 5px;">
                                <div class="label-new">WIP No.</div>
                                <span *ngIf="lastWIPNo" style="color: #777; font-weight: normal; font-size: 12px;">(Prev: {{lastWIPNo}})</span>
                            </div>
                            <input type="text" [(ngModel)]="data.WipNo" class="form-control fn13 formCtlFltr" maxlength="20" style="width: 50%; color: rgb(0, 0, 0); background-color: white !important;">
                        </span>
                    </div>
                </div>

                <!-- Production view -->
                <div class="col-md-12 col-12 col-xs-12"  *ngIf="items.length > 0 && prTypeID == 1" style="margin-top: 10px;">
                
                    <div class="label-new"> Products </div>
                    <div class="heightItems" style="border: 1px solid #ddd; border-radius: 5px;">
                        <!-- {{l ? 'border-bottom: 10px solid #f5f5f5' : ''}} -->
                    <div class="col-md-12 col-12 col-sm-12 "
                            style="display: flex; padding: 5px; margin-top: 0px; border-top: 1px solid #f5f5f5; {{i % 2 != 0 ? 'background-color: #f5f5f5;' : 'background-color: #fff;'}}"
                            *ngFor="let x of items; let l = last; let f = first; let i = index">
                        <div class="col-md-7 col-sm-7 col-7 pad0 font14 inLneBlk" style="vertical-align: -webkit-baseline-middle;">
                            <h4 class="font14" style="margin: 5px;"> {{x.ItemName}}</h4>
                            <h4 *ngIf="x.ItemName != x.ItemCode" class="font14" style="color: #777; padding-left: 5px;">{{x.ItemCode}}</h4>
                        </div>
                        <div class="col-md-5 col-sm-5 col-5 inLneBlk pad0" style="text-align: right;">
                            <span class="inLneBlk" style="width: min-content; margin-right: 10px;"> 
                                <input type="text" id="txtItem"
                                    class="form-control formCtlFltr" tabindex="1" [(ngModel)]="x.PlanQty" placeholder="Qty" (keyup)="checkPrecision(x)"
                                    style="padding: 14px; width: 80px; background: inherit; text-align: right; padding-right: 8px; background-color: #fff;"
                                    maxlength="50" />
                                    
                            </span>
                            
                            <span class="inLneBlk font14"> {{x.SKU}}</span>
                        </div>
                    </div>
                </div>

                    <!-- <div class="inLneBlk" style="margin-top: 20px;margin-left: 15px;">
                        <span class="brownBadge ">
                            <span class="inLneBlk">   Garlic Bread </span>
                            <span class="inLneBlk" style="width: min-content;"> <input type="text" id="txtItem" class="form-control " tabindex="1" placeholder="Qty"
                            title="Item Name" captalize-first style=" height: 20px;padding: 15px; width: 80px;background: inherit; text-align: right;"
                            maxlength="50" />
                            </span>

                            <span class="inLneBlk"> no.s</span>
                        </span>
                    </div> -->
                </div>

                <!-- d-none -->
                <div class="col-md-12 col-12 col-xs-12 pad0" *ngIf="items.length > 0 && prTypeID == 2" style="display: none; padding-bottom: 5px;">
                    <div class="col-md-12 col-12 col-sm-12"
                        style="margin-top:0px;border-top: 5px solid #f5f5f5; {{l ? 'border-bottom: 5px solid #f5f5f5' : ''}}"
                        *ngFor="let x of items; let l = last ; let f = first">
                        <div class="col-md-12 col-sm-12 col-12 pad0 font14 inLneBlk"
                            style="vertical-align: -webkit-baseline-middle;">
                            <h4 class="font14" style="margin-top: 10px;"> {{x.ItemName}}
                            </h4>
                            <h4 *ngIf="x.ItemName != x.ItemCode" class="font14" style="color: #777;">{{x.ItemCode}}</h4>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 10px;">
                
                    <div class="col-md-12 col-12 col-xs-12 pad0" *ngIf="prTypeID == 1"> <!-- data.OrderNo == '' && -->
                        <div class="inLneBlk" style="cursor: pointer;" (click)="openItemSelect()">
                            <span *ngIf="prTypeID == 1" class="orangeBadge brdrRadius3" style="padding: 4px 10px; font-size: 13px !important; margin-right: 10px;">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i> {{items.length > 0 ?'Add more products':
                                'Select Products' }}
                            </span>
                            <!-- <span *ngIf="prTypeID == 2 && items.length == 0"  class="greenBadge" style="padding: 5px 10px 5px; font-size: 13px !important; line-height: 1.66em; ">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i> Select Product
                            </span> -->
                        </div>
                        
                        <div class="inLneBlk" *ngIf="prTypeID == 1 && isCopyDescVisible" style="margin-left: 10px;">
                            <label style="cursor: pointer; margin-bottom: 0;">
                                <input type="checkbox" [(ngModel)]="copyDescFromOrder" style="vertical-align: middle; cursor: pointer; margin-bottom: 2px;" class="chkbox-darkblue">
                                <span style="font-size: 13px; margin-left: 5px;">Copy item description from order</span>
                            </label>
                        </div>
                    </div>

                    <div class="col-md-12 col-12 col-xs-12 pad0" style="margin-top: 10px;" title="Order No." *ngIf="prTypeID == 1 && data.OrderNo != ''">
                        <div style="display: flex; align-items: center;">
                            <div class="label-new">Order No.: </div>
                            <span class="orangeBadge brdrRadius3 orangeBrdr bgwhite" style="padding: 3px 8px;pointer-events: none; color: #333; border-color: #ddd !important; margin-left: 10px;">
                            {{data.OrderNo}}
                            </span>
                        </div>
                    </div>

                    <div class="col-md-12 col-12 col-xs-12 inLneBlk" style="font-size: 13px !important; padding: 0px; {{prTypeID == 2  ? 'margin-top: 0px;' : 'margin-top: 10px;'}}">
                        <!-- Select Comp-list -->
                        <!-- <div *ngIf="prTypeID == 1 && data.cstrName == ''" (click)="openCompModal()" class="greenBadge disblk mrgRgt10 brdrRadius3"
                        style="display: inline-block; padding: 4px 13px; margin-top: 0px; cursor: pointer; font-size: 13px; margin-right: 10px;"> <i
                            class="fa fa-industry" style="margin-right: 5px; font-size: 13px;"></i> 
                            Select Customer 
                            <i class="fa fa-pencil" style="margin-left: 5px; font-size: 12px;"></i>
                        </div> -->
                        <div class="label-new">Customer</div>
                        <div style="display: flex; gap: 10px;">
                            <div type="text" (click)="openCompModal()" placeholder="Select Customer" class="form-control fn13 bzInput bzInputPad" maxlength="100" style="padding: 5px 8px !important;" tabindex="3">
                                <span *ngIf="data.cstrName">{{data.cstrName}}</span>
                                <span *ngIf="!data.cstrName" style="color: #b0b0b0;">Select Customer</span>
                            </div>
                            <span *ngIf="data.cstrName" title="Remove Customer" (click)="removeCustomer()" class="clInField">
                                <i class="zmdi zmdi-close"></i>
                            </span>
                            <!-- <span (click)="removeCustomer()" class="btn-darkGreen-alt height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px; line-height: 26px !important;">
                                <i class="zmdi zmdi-close"></i>
                            </span> -->
                        </div>
                    </div>
                    
                    <!-- Select users -->
                    <div *ngIf="prTypeID == 2" class="col-md-12 col-12 col-xs-12 pad0" style="margin-top: 0px; font-size: 13px !important; padding-top: 13px ;">
                        <div class="label-new">Users</div>
                        <div style="display: flex; gap: 10px; margin-bottom: 10px;">
                            <select class="form-control fn13 bzInput" style="cursor: pointer; padding: 5px !important;" [(ngModel)]="selectedUserID" (change)="selectUser()" tabindex="4">
                                <option value="0">Select Executive</option>
                                <ng-container *ngFor="let u of userList">
                                    <option *ngIf="!u.selected" value="{{u.UserID}}">{{ u.Name }}</option>
                                </ng-container>
                            </select>
                        </div>
                        <div *ngIf="data.users.length > 0" style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 10px;">
                            <div *ngFor="let user of data.users; let i = index;" style="display: inline-block; border: 1px solid #BCC2C9; padding: 5px 7px; border-radius: 3px; color: #333; background: #fff; font-size: 13px; height: 30px !important;">
                                <div style="padding: 0px; margin-left: 5px; display: inline-block;">{{user.Name}}</div>
                                <span title="Remove User" (click)="removeUser(i)" style="font-size: 12px; cursor: pointer; margin-left: 10px; margin-right: 5px; cursor: pointer;">
                                    <i class="zmdi zmdi-close"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- display-none -->
                    <div class="col-md-12 col-12 col-xs-12 inLneBlk" *ngIf="prTypeID == 1 && data.cstrName != ''" style="display: none; font-size: 13px !important; padding: 0px;">
                        <div class="inLneBlk" style="margin-top: 0px;margin-left: 0px; display: flex; align-items: center;">
                            <!-- *ngIf="prTypeID == 2" -->
                            <div class="label-new" >Customer :</div>
                            <span class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="font-size: 13px; display: flex; align-items: center; border: 1px solid #ddd; padding: 6px 10px; color: #333; margin-left: 10px;">
                                <!-- <i class="zmdi zmdi-city-alt" style="margin-right: 5px;"></i>  -->
                                {{data.cstrName}}
                                <i class="zmdi zmdi-close" (click)="removeCustomer()" *ngIf="data.OrderNo == ''" 
                                    style="margin-left: 8px; color: #ddd;"></i>
                            </span>
                        </div>
                    </div>

                </div>

                <div class="col-md-12 col-12 col-xs-12" style="margin-top: 10px; font-size: 13px !important;">
                    <div *ngIf="prTypeID == 2" class="inLneBlk target fieldPad" style="margin-top: 0px; margin-left: 0px; margin-right: 15px;">
                        <div class="label-new">Launch</div>
                        <input matInput readonly (focus)="picker2.open()" (blur)="changeLaunchDT()"  [matDatepicker]="picker2"  [max]="todayDate"  class="form-control bzInput" [(ngModel)]="data.launchDT"
                            style="cursor: pointer; width: 90px; padding: 0px 8px; font-size: 13px; color: #333; height: 28px !important;" tabindex="5"
                        >
                        <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                    </div>
                    <div class="inLneBlk target fieldPad" style="margin-top: 0px; margin-left: 0px;">
                        <div class="label-new">Target</div>
                        <!-- <mat-form-field out class="example-full-width" appearance="outline" style="width: 85px; padding: 0px !important; margin-left: 10px;">
                            <mat-label>Target</mat-label>
                            <input style="margin-top: 0px !important;" matInput readonly [matDatepicker]="picker" [(ngModel)]="data.targetDate" [min]="todayDate" [formControl]="startDate" (focus)="picker.open()"
                                tabindex="1">
                            <mat-datepicker-toggle matSuffix [for]="picker" style="display: none;"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field> -->
                        <input matInput readonly (focus)="picker.open()" (blur)="changeTargetDate()" [matDatepicker]="picker" [min]="todayDate" class="form-control bzInput" [(ngModel)]="data.targetDate" style="cursor: pointer; width: 90px; padding: 0px 8px; font-size: 13px; color: #333; height: 28px !important;" tabindex="5">
                        <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                    </div>

                    <div class="inLneBlk" style="margin-left: 15px; vertical-align: bottom;" *ngIf="allowPrdFile">
                        <div class="label-new">Descriptor</div>

                        <span *ngIf="!fileName" class="btn font13 darkBlueButton padLeft5 brdrRadius3 hvrInfo btnBottom"
                            style="width: fit-content; padding: 5px 12px; cursor: pointer;" (click)="fileInput.click()">
                            <i class="zmdi zmdi-file-plus" style="padding-right: 10px;"></i>Upload File
                        </span>

                        <input #fileInput type="file" id="addAttechment" accept=".pdf,.jpg,.jpeg,.png,.bmp,.gif" (change)="onFileSelected($event)"
                        style="display: none;">
                        
                        <div *ngIf="fileName" style="position: relative; display: inline-block; width: 200px;">
                            <input type="text" [value]="fileName" disabled class="form-control bzInput" 
                                style="padding: 0px 30px 0px 8px; font-size: 12px; color: #333; height: 30px !important; line-height: 30px; background-color: white !important; cursor: not-allowed;">
                            <span title="Remove File" (click)="removeFile()" style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); cursor: pointer; font-size: 14px; color: #999;">
                                <i class="zmdi zmdi-close"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- display-none -->
                <div class="col-md-12 col-12 col-xs-12 mrgnBtm70" style="margin-top: 0px;margin-bottom: 15px; display: none;" title="Order No." *ngIf="prTypeID == 1 && data.OrderNo != ''">
                    <span class="label-new">Order No.</span>
                    <span class="orangeBadge brdrRadius3 orangeBrdr bgwhite" style="padding: 3px 8px;pointer-events: none;">
                    {{data.OrderNo}}
                    </span>
                </div>

                <div class="col-md-12 col-12 col-xs-12 mrgnBtm70" style="margin-top: 10px; font-size: 13px !important;">
                    <div style="margin-top: 0px;margin-left: 0px;">
                        <!-- <mat-form-field out class="example-full-width myText brdrRadius3 " appearance="outline"
                        style="width: 100%;padding-bottom: 10px ;">
                        <mat-label>Special Instruction</mat-label>
                        <textarea matInput rows="2" style="resize: none;" [(ngModel)]="data.instruction" maxlength="200"
                        tabindex="1"></textarea>
                    </mat-form-field> -->
                        <div class="label-new">Special Instruction</div>
                        <textarea rows="4" [(ngModel)]="data.instruction" maxlength="200" placeholder="Enter Instruction" 
                            class="txtArea fn13 brdrRadius3" style="border-color: #ddd; resize: none; padding: 5px 8px; color: #555;" tabindex="6"></textarea>
                    </div>
                </div>
            </div>

            <!-- project view (right)-->
            <div class="col-md-6 col-6 col-xs-6 pad0">
                <div class="col-md-12 col-12 col-xs-12 pad0"  *ngIf="prTypeID == 2" style="padding-bottom: 5px;">
                    <div class="col-md-12 col-12 col-sm-12 "style="margin-top: 0px; margin-bottom: 10px;">
                        <!-- <div class="col-md-4 col-sm-4 col-xs-4 pad0 font14 inLneBlk"
                            style="vertical-align: -webkit-baseline-middle; font-size: 15px; width: 30%;">
                            <h4 class="font14" style="margin-top: 5px; font-size: 16px;">Product(s) </h4>
                        </div>
                        <div class="col-md-8 col-sm-8 col-xs-8 inLneBlk pad0" title="Select Product" style="width: 70%;text-align: right; padding-top: 5px;
                                padding-bottom: 5px;">
                            <span  class="orangeBadge brdrRadius3 orangeBrdr" (click)="openItemSelect()" style="padding: 4px 10px; cursor: pointer; margin-right: 10px;font-size: 13px !important; line-height: 1.66em;">
                            Select Product
                            </span>
                            <span  class="greenBadge brdrRadius3 greenBrdr" (click)="openEntryModal()" title="Add Product" style="padding: 3px 11px; cursor: pointer; font-size: 14px !important; line-height: 1.66em;">
                                <i class="zmdi zmdi-plus" ></i>
                            </span>
                        </div> -->
                        <div class="label-new">Project Type</div>
                        <div style="display: flex; gap: 10px;">
                            <div type="text" (click)="openItemSelect()" placeholder="Select Project Type" class="form-control fn13 bzInput" maxlength="100" style="padding: 5px 8px !important;" tabindex="2">
                                <span *ngIf="projectType">{{projectType}}</span>
                                <span *ngIf="!projectType" style="color: #b0b0b0;">Enter Project Type</span>
                            </div>
                            <span *ngIf="projectType" title="Remove Project Type" style="right: 16px" (click)="removeProjectType()" class="clInField">
                                <i class="zmdi zmdi-close"></i>
                            </span>
                            <!-- <span (click)="removeProjectType()" class="btn-darkGreen-alt height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px; line-height: 26px !important;">
                                <i class="zmdi zmdi-close"></i>
                            </span> -->
                        </div>
                        <!-- <div class="col-md-7 col-sm-7 col-7 inLneBlk pad0 mobView" style="text-align: right; padding-top: 5px;
                        padding-bottom: 5px;">
                            <span  class="orangeBadge" (click)="openItemSelect()"  style="padding: 5px 10px 5px;cursor: pointer; margin-right: 5px;font-size: 13px !important; line-height: 1.66em; ">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i> Select Product
                            </span>
                            <span  class="greenBadge" (click)="openEntryModal()" style="padding: 5px 10px 5px;cursor: pointer; font-size: 13px !important; line-height: 1.66em; ">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i>
                            </span>
                        </div> -->
                    </div>
        
                    <div class="col-md-12 col-12 col-sm-12"style="margin-top: 0px; margin-bottom: 10px;">
                        <div class="label-new">Stages</div>
                        <div style="display: flex; gap: 10px; margin-bottom: 10px;">
                            <input type="text" [(ngModel)]="newStage" class="form-control fn13 bzInput" placeholder="Enter Stage" tabindex="7"
                                    maxlength="50" style="padding: 5px 8px !important;"/>
                            <span title="Add Stage" (click)="addStage()" class="btn-darkGreen-alt height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px; line-height: 26px !important;">
                                <i class="zmdi zmdi-check"></i>
                            </span>
                            <span *ngIf="newStage" title="Remove Stage" (click)="clearAddStage()" class="clInField" style="right: 60px;">
                                <i class="zmdi zmdi-close"></i>
                            </span>
                            <!-- <span (click)="clearAddStage()" class="btn-darkGreen-alt height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px; line-height: 26px !important;">
                                <i class="zmdi zmdi-close"></i>
                            </span> -->
                        </div>
                        <!-- <div *ngIf="data.Stages.length > 0" style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 10px;">
                            <div *ngFor="let stage of data.Stages; let i = index;" style="display: inline-block; border: 1px solid #BCC2C9; padding: 5px 7px; border-radius: 3px; color: #333; background: #fff; font-size: 13px; height: 30px !important;">
                                <div style="padding: 0px; margin-left: 5px; display: inline-block;">{{i+1}}. {{stage.SNm}}</div>
                                <span title="Remove Stage" (click)="removeStage(i)" style="font-size: 12px; cursor: pointer; margin-left: 10px; margin-right: 5px; cursor: pointer;">
                                    <i class="zmdi zmdi-close"></i>
                                </span>
                            </div>
                        </div> -->
                        <div *ngIf="data.Stages.length > 0" style="overflow-y: auto; max-height: 60vh; border-radius: 3px;">
                            <table class="table table-bordered" style="font-size: 12px; background-color: white;">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">No.</th>
                                        <th style="width: 60%;">Stage</th>
                                        <th style="width: 20%;">Due on</th>
                                        <th style="width: 5%;"></th> 	
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let stage of data.Stages; let i = index;" style="color: #555;">
                                        <td style="vertical-align: top; text-align: right;">{{i+1}}</td>
                                        <td style="vertical-align: top;">{{stage.SNm}}</td>
                                        <td style="vertical-align: top;">
                                            <div>
                                              <input matInput readonly
                                                (focus)="picker.open()"
                                                [matDatepicker]="picker" [min]="data.launchDT" [max]="data.targetDate" [(ngModel)]="stage.TDT"
                                                class="form-control bzInput"
                                                style="cursor: pointer; width: 90px; padding: 0px 8px; font-size: 12px; height: 28px !important;">
                                              <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                                            </div>
                                          </td>
                                        <td style="vertical-align: middle;">
                                            <span  class="lableBtnGray" (click)="removeStage(i)"  title="Delete" style="border-radius: 10px; vertical-align: middle; cursor: pointer;">
                                                <i class="fa fa-trash"></i></span>
                                        </td>                           
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        

        <div class="col-md-12 col-12 col-xs-12 webView" style="margin-top: 10px; margin-bottom: 15px;">
            <!-- <span class="btn btn-orange" style="cursor: pointer;background: #e88421;color: #fff; border-radius: 25px; padding: 5px 14px 4px; font-size: 14px; line-height: 1.66em; " (click)= "save()">
                <i class="fa fa-check" style="margin-right: 5px;"></i> Save
            </span> -->

            <span class="btn-darkGreen brdrRadius3" style=" margin-left: 0px;padding: 2px 9px 2px;" (click)= "save()">
                <span style="margin-right: 5px; font-size: 13px;"><i class="fa fa-check"></i></span>
               <span style="font-size: 13px;">Save </span>
            </span>
        </div>

        <!-- mobView -->
        <div *ngIf="isMobileView" class="col-md-12 col-12 col-xs-12 Pad0 mobView" style="padding: 0px;">
            <!-- left -->
            <div class="col-md-12 col-12 col-xs-12 pad0">
                <div class="col-md-12 col-12 col-xs-12 pad0" style="margin-top: 0px;">
                    <!-- <div class="col-md-3 col-4 col-sm-12  inLneBlk  padHeder" style="padding-bottom: 0px;">
                        <span> Job No : </span>
                    </div> -->
                    <div class="col-md-12 col-12 col-sm-12  inLneBlk  padHeder">
                        <span *ngIf="prTypeID == 2">
                            <div style="display: flex; gap: 5px;">
                                <div class="label-new">Project Title</div>
                            <span *ngIf="lastProjectWIPNo" style="color: #777; font-weight: normal; font-size: 12px; padding-bottom: 5px;">(Prev: {{lastProjectWIPNo}})</span>
                            </div>
                            <input type="text" [(ngModel)]="data.projectWipNo" class="form-control fn13 bzInput" maxlength="100" style="color: rgb(0, 0, 0); background-color: white !important;" tabindex="1">

                        </span>

                        <span *ngIf="prTypeID == 1">
                            <div class="label-new">WIP No.</div>
                            <input type="text" [(ngModel)]="data.WipNo" class="form-control fn13 formCtlFltr" maxlength="20" style="color: rgb(0, 0, 0); background-color: white !important;">
                            <span *ngIf="lastWIPNo" style="color: #777; font-weight: normal; font-size: 13px;">(Prev: {{lastWIPNo}})</span>
                        </span>
                    </div>
                </div>

                <!-- Production view -->
                <div class="col-md-12 col-12 col-xs-12"  *ngIf="items.length > 0 && prTypeID == 1" style="margin-top: 10px;">
                    <div class="label-new"> Products </div>
                    <div class="heightItems" style="border: 1px solid #ddd; border-radius: 5px;">
                        <!-- {{l ? 'border-bottom: 10px solid #f5f5f5' : ''}} -->
                        <div class="col-md-12 col-12 col-sm-12 "
                                style="display: flex; padding: 5px; margin-top: 0px; border-top: 1px solid #f5f5f5; {{i % 2 != 0 ? 'background-color: #f5f5f5;' : 'background-color: #fff;'}}"
                                *ngFor="let x of items; let l = last; let f = first; let i = index">
                            <div class="col-md-7 col-sm-7 col-7 pad0 font14 inLneBlk" style="vertical-align: -webkit-baseline-middle;">
                                <h4 class="font14" style="margin: 5px;"> {{x.ItemName}}</h4>
                                <h4 *ngIf="x.ItemName != x.ItemCode" class="font14" style="color: #777; padding-left: 5px;">{{x.ItemCode}}</h4>
                            </div>
                            <div class="col-md-5 col-sm-5 col-5 inLneBlk pad0" style="text-align: right;">
                                <span class="inLneBlk" style="width: min-content; margin-right: 10px;"> 
                                    <input type="text" id="txtItem"
                                        class="form-control formCtlFltr" tabindex="1" [(ngModel)]="x.PlanQty" placeholder="Qty" (keyup)="checkPrecision(x)"
                                        style="padding: 14px; width: 80px; background: inherit; text-align: right; padding-right: 8px; background-color: #fff;"
                                        maxlength="50" />
                                        
                                </span>
                                
                                <span class="inLneBlk font14"> {{x.SKU}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- d-none -->
                <div class="col-md-12 col-12 col-xs-12 pad0" *ngIf="items.length > 0 && prTypeID == 2" style="display: none; padding-bottom: 5px;">
                    <div class="col-md-12 col-12 col-sm-12"
                        style="margin-top:0px;border-top: 5px solid #f5f5f5; {{l ? 'border-bottom: 5px solid #f5f5f5' : ''}}"
                        *ngFor="let x of items; let l = last ; let f = first">
                        <div class="col-md-12 col-sm-12 col-12 pad0 font14 inLneBlk"
                            style="vertical-align: -webkit-baseline-middle;">
                            <h4 class="font14" style="margin-top: 10px;"> {{x.ItemName}}
                            </h4>
                            <h4 *ngIf="x.ItemName != x.ItemCode" class="font14" style="color: #777;">{{x.ItemCode}}</h4>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 10px;">
                    <div class="col-md-12 col-12 col-xs-12 pad0" *ngIf="prTypeID == 1"> <!-- data.OrderNo == '' && -->
                        <div class="inLneBlk" *ngIf="prTypeID == 1 && isCopyDescVisible" style="margin: 10px 0px; display: block;">
                            <label style="cursor: pointer; margin-bottom: 0;">
                                <input type="checkbox" [(ngModel)]="copyDescFromOrder" style="vertical-align: middle; cursor: pointer;" class="chkbox-darkblue">
                                <span style="font-size: 13px; margin-left: 5px;">Copy item description from order</span>
                            </label>
                        </div>
                        <div class="inLneBlk" style="cursor: pointer;" (click)="openItemSelect()">
                            <span *ngIf="prTypeID == 1" class="orangeBadge brdrRadius3" style="padding: 4px 10px; font-size: 13px !important; margin-right: 10px;">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i> {{items.length > 0 ?'Add more products':
                                'Select Products' }}
                            </span>
                            <!-- <span *ngIf="prTypeID == 2 && items.length == 0"  class="greenBadge" style="padding: 5px 10px 5px; font-size: 13px !important; line-height: 1.66em; ">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i> Select Product
                            </span> -->
                        </div>
                    </div>

                    <div class="col-md-12 col-12 col-xs-12 pad0" style="margin-top: 10px;" title="Order No." *ngIf="prTypeID == 1 && data.OrderNo != ''">
                        <div style="display: flex; align-items: center;">
                            <div class="label-new">Order No.: </div>
                            <span class="orangeBadge brdrRadius3 orangeBrdr bgwhite" style="padding: 3px 8px;pointer-events: none; color: #333; border-color: #ddd !important; margin-left: 10px;">
                            {{data.OrderNo}}
                            </span>
                        </div>
                    </div>

                    <!-- project view-->
                    <div class="col-md-12 col-12 col-xs-12 pad0"  *ngIf="prTypeID == 2" style="padding-bottom: 5px;">
                        <div class="col-md-12 col-12 col-sm-12 pad0"style="margin-top: 0px; margin-bottom: 10px;">
                            <div class="label-new">Project Type</div>
                            <div style="display: flex; gap: 10px;">
                                <div type="text" (click)="openItemSelect()" placeholder="Select Project Type" class="form-control fn13 bzInput" style="padding: 5px 8px !important;" tabindex="2">
                                    <span *ngIf="projectType">{{projectType}}</span>
                                    <span *ngIf="!projectType" style="color: #b0b0b0;">Enter Project Type</span>
                                </div>
                                <span *ngIf="projectType" title="Remove Customer" (click)="removeProjectType()" class="clInField">
                                    <i class="zmdi zmdi-close"></i>
                                </span>
                            </div>
                        </div>
            
                        <div class="col-md-12 col-12 col-sm-12 pad0"style="margin-top: 0px; margin-bottom: 10px;">
                            <div class="label-new">Stages</div>
                            <div style="display: flex; gap: 10px; margin-bottom: 10px;">
                                <input type="text" [(ngModel)]="newStage"  class="form-control fn13 bzInput" maxlength="50" style="color: rgb(0, 0, 0); background-color: white !important;" tabindex="3">
                                <span title="Add Stage" (click)="addStage()" class="btn-darkGreen-alt height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px; line-height: 26px !important;">
                                    <i class="zmdi zmdi-check"></i>
                                </span>
                                <span *ngIf="newStage" title="Remove Stage" (click)="clearAddStage()" class="clInField">
                                    <i class="zmdi zmdi-close"></i>
                                </span>
                                <!-- <span (click)="clearAddStage()" class="btn-darkGreen-alt height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px; line-height: 26px !important;">
                                    <i class="zmdi zmdi-close"></i>
                                </span> -->
                            </div>
                            <div *ngIf="data.Stages.length > 0" style="overflow-y: auto; border-radius: 3px;">
                                <table class="table table-bordered" style="font-size: 12px; background-color: white;">
                                    <thead>
                                        <tr>
                                            <th style="width: 5%;">No.</th>
                                            <th style="width: 60%;">Stage</th>
                                            <th style="width: 20%;">Due on</th>
                                            <th style="width: 5%;"></th> 	
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let stage of data.Stages; let i = index;">
                                            <td style="vertical-align: top; text-align: right;">{{i+1}}</td>
                                            <td style="vertical-align: top;">{{stage.SNm}}</td>
                                            <td style="vertical-align: top;">
                                                <div>
                                                <input matInputreadonly
                                                    (focus)="picker.open()"
                                                    [matDatepicker]="picker" [min]="data.launchDT" [max]="data.targetDate" [(ngModel)]="stage.TDT"
                                                    class="form-control bzInput"
                                                    style="cursor: pointer; width: 90px; padding: 0px 8px; font-size: 12px; height: 28px !important;">
                                                <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                                                </div>
                                            </td>
                                            <td style="vertical-align: middle;">
                                                <span  class="lableBtnGray" (click)="removeStage(i)"  title="Delete" style="border-radius: 10px; vertical-align: middle; cursor: pointer;">
                                                    <i class="fa fa-trash"></i></span>
                                            </td>                           
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 col-12 col-xs-12 inLneBlk" style="font-size: 13px !important; padding: 0px; {{prTypeID == 2  ? 'margin-top: 0px;' : 'margin-top: 10px;'}}">
                        <div class="label-new">Customer</div>
                        <div style="display: flex; gap: 10px;">
                            <div type="text" (click)="openCompModal()" placeholder="Select Customer" class="form-control fn13 bzInput bzInputPad" maxlength="100" style="padding: 5px 8px !important;" tabindex="4">
                                <span *ngIf="data.cstrName">{{data.cstrName}}</span>
                                <span *ngIf="!data.cstrName" style="color: #b0b0b0;">Select Customer</span>
                            </div>
                            <span *ngIf="data.cstrName" title="Remove Customer" (click)="removeCustomer()" class="clInField">
                                <i class="zmdi zmdi-close"></i>
                            </span>
                        </div>
                    </div>
                    
                    <!-- Select users -->
                    <div *ngIf="prTypeID == 2" class="col-md-12 col-12 col-xs-12 pad0" style="margin-top: 0px;font-size: 13px !important; padding-top: 13px ;">
                        <div class="label-new">Users</div>
                        <div style="display: flex; gap: 10px; margin-bottom: 10px;">
                            <select class="form-control fn13 formCtlFltr" style="cursor: pointer; padding: 0; background-color: white !important;" [(ngModel)]="selectedUserID" (change)="selectUser()" tabindex="5">
                                <option value="0">Select Executive</option>
                                <ng-container *ngFor="let u of userList">
                                    <option *ngIf="!u.selected" value="{{u.UserID}}">{{ u.Name }}</option>
                                </ng-container>
                            </select>
                        </div>
                        <div *ngIf="data.users.length > 0" style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 10px;">
                            <div *ngFor="let user of data.users; let i = index;" style="display: inline-block; border: 1px solid #BCC2C9; padding: 5px 7px; border-radius: 3px; color: #333; background: #fff; font-size: 13px; height: 30px !important;">
                                <div style="padding: 0px; margin-left: 5px; display: inline-block;">{{user.Name}}</div>
                                <span title="Remove User" (click)="removeUser(i)" style="font-size: 12px; cursor: pointer; margin-left: 10px; margin-right: 5px; cursor: pointer;">
                                    <i class="zmdi zmdi-close"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- display-none -->
                    <div class="col-md-12 col-12 col-xs-12 inLneBlk" *ngIf="prTypeID == 1 && data.cstrName != ''" style="display: none; font-size: 13px !important; padding: 0px;">
                        <div class="inLneBlk" style="margin-top: 0px;margin-left: 0px; display: flex; align-items: center;">
                            <!-- *ngIf="prTypeID == 2" -->
                            <div class="label-new" >Customer :</div>
                            <span class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="font-size: 13px; display: flex; align-items: center; border: 1px solid #ddd; padding: 6px 10px; color: #333; margin-left: 10px;">
                                <!-- <i class="zmdi zmdi-city-alt" style="margin-right: 5px;"></i>  -->
                                {{data.cstrName}}
                                <i class="zmdi zmdi-close" (click)="removeCustomer()" *ngIf="data.OrderNo == ''" 
                                    style="margin-left: 8px; color: #ddd;"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 col-12 col-xs-12" style="margin-top: 10px; font-size: 13px !important; display: flex; flex-direction: column; gap: 10px;">
                    <!-- Launch and Target in same row -->
                    <div *ngIf="prTypeID == 2" style="display: flex; gap: 10px; align-items: flex-start;">
                        <div class="inLneBlk target fieldPad" style="margin-top: 0px; margin-left: 0px;">
                            <div class="label-new">Launch</div>
                            <input matInput readonly (focus)="picker2.open()" (blur)="changeLaunchDT()" 
                            [matDatepicker]="picker2" [max]="todayDate" [(ngModel)]="data.launchDT"
                            class="form-control bzInput" style="height: 28px !important; cursor: pointer; width: 90px; padding: 0px 8px; font-size: 13px; color: #333; border: 1px solid #BCC2C9;" tabindex="6">
                            <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                        </div>
                        <div class="inLneBlk target fieldPad" style="margin-top: 0px; margin-left: 0px;">
                            <div class="label-new">Target</div>
                            <input matInput readonly (focus)="picker.open()" (blur)="changeTargetDate()" 
                            [matDatepicker]="picker" [min]="todayDate" [(ngModel)]="data.targetDate"
                            class="form-control bzInput" style="height: 28px !important; cursor: pointer; width: 90px; padding: 0px 8px; font-size: 13px; color: #333; border: 1px solid #BCC2C9;" tabindex="6">
                            <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                        </div>
                    </div>

                    <!--File-->
                    <div class="inLneBlk" style="margin-left: 0px; vertical-align: initial; display: flex; flex-direction: column; gap: 5px;" *ngIf="allowPrdFile">
                        <span *ngIf="!fileName" class="btn font13 darkBlueButton padLeft5 brdrRadius3 hvrInfo btnBottom"
                            style="width: fit-content; padding: 5px 12px; cursor: pointer;" (click)="fileInputMob.click()">
                            <i class="zmdi zmdi-file-plus" style="padding-right: 10px;"></i>Upload File
                        </span>

                        <input #fileInputMob type="file" id="addAttechmentMob" accept=".pdf,.jpg,.jpeg,.png,.bmp,.gif" (change)="onFileSelected($event)"
                        style="display: none;">
                        
                        <div *ngIf="fileName" style="position: relative; display: inline-block; width: 100%;">
                            <input type="text" [value]="fileName" disabled class="form-control bzInput" 
                                style="padding: 0px 30px 0px 8px; font-size: 12px; color: #333; height: 30px !important; line-height: 30px; background-color: white !important; cursor: not-allowed; border: 1px solid #BCC2C9;">
                            <span title="Remove File" (click)="removeFile()" style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); cursor: pointer; font-size: 14px; color: #999;">
                                <i class="zmdi zmdi-close"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- display-none -->
                <div class="col-md-12 col-12 col-xs-12 mrgnBtm70" style="margin-top: 0px;margin-bottom: 15px; display: none;" title="Order No." *ngIf="data.OrderNo != ''">
                    <span class="label-new">Order No.</span>
                    <span class="orangeBadge brdrRadius3 orangeBrdr bgwhite" style="padding: 3px 8px;pointer-events: none;">
                    {{data.OrderNo}}
                    </span>
                </div>

                <div class="col-md-12 col-12 col-xs-12 mrgnBtm70" style="margin-top: 10px; font-size: 13px !important;">
                    <div style="margin-top: 0px;margin-left: 0px;">
                        <div class="label-new">Special Instruction</div>
                        <textarea rows="4" [(ngModel)]="data.instruction"  maxlength="200"  class="txtArea fn13 brdrRadius3" style="border-color: #DDD; resize: none;" tabindex="7"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-12 col-xs-12 mobView"
            style="margin-top: 15px;position: fixed; bottom: 20px;text-align: center;">
            <span class="btn btn-darkGreen brdrRadius3" style="cursor: pointer; color: #fff;border-radius: 3px; padding: 0px 10px; line-height: 36px;" (click)= "save()">
                <i class="fa fa-check" style="margin-right: 5px;"></i> Save
            </span>
        </div>
    </div>
</div>


<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <app-multiple-select-item></app-multiple-select-item>
</ng-template>

